module.exports = "/static/Images/pt-br/Unsatisfied.png";